import selectGameKeys from './select-game-keys';
import { selectBestScoreNumber } from './best-score';

const getGameStats = (games, stats) => games.map(({ score, lasers, speed }) => ({
  stats: [
    [stats.buttonsHit, score],
    [stats.buttonsHitPerSec, speed],
    [stats.lasersBroken, lasers],
  ],
  score,
}));

const selectScoreCardSpecialOps = (
  { specialOps },
  phrases,
  specialOpsVideoUrl,
  specialOpsVideoPagePath,
) => {
  if (!specialOps) return null;

  const bestScore = selectBestScoreNumber(specialOps.games, 'score');
  const { timesPlayed } = specialOps;
  const { headings, specialOps: specialOpsPhrases, summary } = phrases;

  return {
    gameTitle: specialOpsPhrases.gameTitle,
    noVideoSessionImageUrl: '//images.ctfassets.net/gtqjh9j40j4m/4TSF1MAa2PArZfbkiLwRaL/523333d1fc0280adf19670784c4a7ce6/no-special-ops-video-fallback.jpg',
    imageUrl: 'https://images.ctfassets.net/gtqjh9j40j4m/1vyJ3K6MtzCRRxNXzggMBH/5c52e2f5d9e9c52392ea9fb4e5c74c83/special-ops-player.jpg',
    specialOpsVideoUrl,
    specialOpsVideoPagePath,
    summary: [
      {
        key: 'missions',
        value: timesPlayed,
        units: null,
        descriptor: summary.timesPlayed,
      },
      {
        key: 'best-score',
        value: bestScore,
        units: specialOpsPhrases.stats.buttonsHit,
        descriptor: summary.bestScore,
      },
    ],
    stats: getGameStats(specialOps.games, specialOpsPhrases.stats),
    sessions: specialOps.games.map(({ sessionId }) => sessionId),
    videosBeingProcessed: specialOps
      .games.map(({ isVideoBeingProcessed }) => isVideoBeingProcessed),
    ...selectGameKeys({ specialOps }),
    phrases: {
      headings,
      ...specialOpsPhrases,
    },
  };
};

export default selectScoreCardSpecialOps;
